/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';

export default class ReCAPTCHA extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  execute({ action } = {}) {
    const { grecaptcha, onChange } = this.props;

    if (grecaptcha && grecaptcha.enterprise) {
      return grecaptcha.enterprise
        .execute(this.props.sitekey, { action })
        .then((token) => {
          if (onChange) {
            onChange(token);
          }
          return token;
        })
        .catch((error) => {
          const errMsg = error?.message || error || 'Unknown error';
          throw new Error(`reCAPTCHA execution failed: ${errMsg}`);
        });
    }
    return null;
  }

  reset() {
    const { grecaptcha } = this.props;

    if (grecaptcha && grecaptcha.enterprise) {
      grecaptcha.enterprise.reset(this.props.sitekey);
    }
  }

  render() {
    return null;
  }
}

ReCAPTCHA.displayName = 'ReCAPTCHA';
ReCAPTCHA.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  grecaptcha: PropTypes.object,
  sitekey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
ReCAPTCHA.defaultProps = {
  sitekey: window.GOOGLE_RECAPTCHA_SITE_KEY,
};
